import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchWholeMaster, loaderStart, loaderStop } from './../features/HomeMaster';
import { toast } from 'react-toastify';

export const FancyExtra = () => {
    const dispatch = useDispatch()
    const [master, setMas] = useState([])
    const loader = useSelector(state => state.homeMaster?.loader)

    const [resultPop, setResultPop] = useState()
    const [resultData, setResultData] = useState({
        winerId: "",
    })

    const onResultDChange = (e) => {
        setResultData({ ...resultData, [e.target.name]: e.target.value })
    }

    const onResultSelectChange = (e) => {
        setResultData({ ...resultData, winerId: e.target.value })
    }

    const openResultPop = (data) => {
        setResultPop(data)
    }

    const saveResult = async (mid, wid, name) => {
        if (window.confirm("Please confirm winner that is " + wid + " for " + name)) {
            if (window.confirm("Please confirm again your winner id = " + wid + " and runner = " + name)) {
                giveResultToMongo(mid, wid)
                giveResultToVelki(mid, wid)
                giveResultToPOSTGFANCY(mid, wid)
                giveResultToMaster(mid, wid)
                giveResultToParker(mid, wid)
                return
            }
        }
        return
    }

    const giveResultToMaster = async (mid, wid) => {
        // const bodyData = [
        //     {
        //         "stMarketID": mid,
        //         "stSelectionID": wid,
        //         "stDetail": "test",
        //         "stStatus": "0",
        //         "stSportsID": "0"
        //     }
        // ]
        const res2 = await fetch('https://addapiresult.9xxbet.com/api/admin/DeletebyMid?mid=' + mid + "&winnername=" + wid, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
        const data2 = await res2.json()
        if (data2 === 'sucess') {
            toast.success("result updated to master")
        }
    }

    const giveResultToParker = async (mid, wid) => {
        const bodyData = [
            {
                "stMarketID": mid,
                "stSelectionID": wid,
                "stDetail": "test",
                "stStatus": "0",
                "stSportsID": "0"
            }
        ]
        const res2 = await fetch('https://postresultparker.fun4club.com/api/admin/SaveResultNew', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(bodyData)
        })
        const data2 = await res2.json()
        if (data2 === 'sucess') {
            toast.success("result updated to parker")
        }
    }

    const giveResultToMongo = async (mid, wid) => {
        const res = await fetch(`https://nodebb.radhe99.com/api/saveresult?mid=${mid}&wid=${wid}`)
        const data = await res.json()
        if (data?.success) {
            toast.success("Result has been uploaded successfully")
        } else {
            toast.error("Server error in Mongo")
        }
    }

    const giveResultToVelki = async (mid, wid) => {
        const bodyData = [
            {
                "stMarketID": mid,
                "stSelectionID": wid,
                "stDetail": "test",
                "stStatus": "0",
                "stSportsID": "0"
            }
        ]
        const res2 = await fetch('https://postresultapivelki.9xxbet.com/api/admin/SaveResultNew', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(bodyData)
        })
        const data2 = await res2.json()
        if (data2 === 'sucess') {
            toast.success("result updated to velki")
        }
    }
    const giveResultToPOSTGFANCY = async (mid, wid) => {
        const bodyData =
        {
            "mid": mid,
            "sid": wid,
        }
        const res2 = await fetch('https://postg.9xxbet.com/api/v1/result/postresultfancy', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(bodyData)
        })
        const data2 = await res2.json()
        if (data2.status === 'success') {
            toast.success("result updated to postgrey")
        }
    }

    useEffect(() => {
        dispatch(fetchWholeMaster()).then((data) => {
            setMas(data.payload)
        })
    }, [])

    return (
        <div className='container-fluid page-body-wrapper'>
            <div _ngcontent-pne-c49="" className="main-panel">
                <div _ngcontent-pne-c49="" className="content-wrapper">
                    <div style={{ marginTop: "100px" }} _ngcontent-pne-c58="" className="row">
                        <div style={{ marginTop: "150px" }} className='col-md-8 position-relative'>
                            <div className='detailScreen'>
                                {
                                    <div className="row">
                                        {
                                            <div className="col-12">
                                                <div _ngcontent-mck-c66="" className="market_section_parent13">
                                                </div>
                                                <div _ngcontent-mck-c66="" className="market_section twoOddsSection">
                                                    <div className='d-flex'>
                                                        {/* <span onClick={() => { setActiveFancy(2) }} _ngcontent-mck-c66="" className="fancyTitle active">Auto fancy</span>
                                                        <span onClick={() => { setActiveFancy(1) }} _ngcontent-mck-c66="" className="fancyTitle">Manual fancy</span>
                                                        <span _ngcontent-mck-c66="" data-bs-toggle="modal" data-bs-target="#manual-toss-market" className="fancyTitle">Add Toss Market</span>
                                                        <span onClick={() => { openHistoryPop() }} _ngcontent-mck-c66="" className="fancyTitle">Fancy history</span>
                                                        <span onClick={() => { ballRunningAll(homeMaster.filter(a => a.stSportsID === "0").map(a => a.stMarketID)) }} _ngcontent-mck-c66="" className="fancyTitle">Ball Running All</span> */}
                                                    </div>
                                                    <div className='manual-fancy'>
                                                        <div _ngcontent-mck-c66="" className="fancyTabs">
                                                            <tabset _ngcontent-mck-c66="" type="tabs" _nghost-mck-c38="" className="tab-container">
                                                                <div _ngcontent-mck-c66="" className="fancyTabs">
                                                                    <div _ngcontent-mck-c38="" className="tab-content">
                                                                        <tab _ngcontent-mck-c66="" id="tab1" role="tabpanel" aria-labelledby="tab1-link" className="tab-pane active">
                                                                            <div _ngcontent-mck-c66="" className="balance-panel-body">
                                                                                <div _ngcontent-mck-c66="" className="row align-items-center oddsHeader">
                                                                                    <div _ngcontent-mck-c66="" className="col-lg-6 col-md-5 col-8 px-0"></div>
                                                                                    <div _ngcontent-mck-c66="" className="col-lg-6 col-md-7 col-4 px-0">
                                                                                        <div _ngcontent-mck-c66="" className="btn-group">
                                                                                            <button _ngcontent-mck-c66="" className="ex-bl" fdprocessedid="209ql8"></button>
                                                                                            <button _ngcontent-mck-c66="" className="ex-bl" fdprocessedid="5bifa"></button>
                                                                                            <button _ngcontent-mck-c66="" className="lay" fdprocessedid="e45wd">no</button>
                                                                                            <button _ngcontent-mck-c66="" className="back" fdprocessedid="kt6yxl">yes</button>
                                                                                            <button _ngcontent-mck-c66="" className="ex-bl" fdprocessedid="l0kbxq"></button>
                                                                                            <button _ngcontent-mck-c66="" className="ex-bl" fdprocessedid="cs2cco"></button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <app-fancy-detail _ngcontent-mck-c66="" _nghost-mck-c63="">
                                                                                    {
                                                                                        master.filter(a => a.stSportsID === '0')?.map((session) => (
                                                                                            <div style={{ backgound: 'white' }} _ngcontent-mck-c63="">
                                                                                                <div _ngcontent-mck-c63="" className="fancy_rows">
                                                                                                    <div _ngcontent-mck-c63="" className="row mx-0 align-items-center">
                                                                                                        <div _ngcontent-mck-c63="" className="col-lg-6 col-md-5 col-8 px-0">
                                                                                                            <button onClick={() => {
                                                                                                            }} className='btn btn-primary'>
                                                                                                                Ball run
                                                                                                            </button>

                                                                                                            <span _ngcontent-mck-c63="" className="marketevent">
                                                                                                                <i _ngcontent-mck-c63="" class="fa fa-location-arrow"></i>
                                                                                                                {session.stMarketName}
                                                                                                            </span>
                                                                                                            <button onClick={() => {
                                                                                                            }} className='btn btn-danger'>
                                                                                                                Hide
                                                                                                            </button>
                                                                                                            <span className='d-flex'>
                                                                                                                <button onClick={() => {
                                                                                                                    setResultData({
                                                                                                                        winerId: ""
                                                                                                                    })
                                                                                                                    openResultPop(session)
                                                                                                                }} _ngcontent-mck-c63="" className="btn btn-primary text-white d-none-desktop" fdprocessedid="2870zc">
                                                                                                                    Close
                                                                                                                </button>
                                                                                                                <button data-bs-toggle="modal" data-bs-target="#delete-popup" onClick={() => {
                                                                                                                    setResultData({
                                                                                                                        winerId: ""
                                                                                                                    })
                                                                                                                    openResultPop(session)
                                                                                                                }} _ngcontent-mck-c63="" className="btn btn-danger text-white d-none-desktop" fdprocessedid="2870zc">
                                                                                                                    Delete
                                                                                                                </button>
                                                                                                            </span>
                                                                                                            <a _ngcontent-mck-c63="" data-toggle="tooltip" data-placement="top" className="mobile-tooltip" title="max:100 | mkt:1 lakh">
                                                                                                                <i _ngcontent-mck-c63="" className="fa fa-info-circle mdi mdi-information"></i>
                                                                                                            </a>

                                                                                                        </div>
                                                                                                        <div _ngcontent-mck-c63="" className="col-lg-6 col-md-7 col-4 px-0">
                                                                                                            <div _ngcontent-mck-c63="" className="btn-group">
                                                                                                                <button _ngcontent-mck-c63="" className="ex-bl" fdprocessedid="8egdtu"></button>

                                                                                                                <button _ngcontent-mck-c63="" className="ex-bl" fdprocessedid="w1m0ja"></button>

                                                                                                                <div _ngcontent-mck-c63="" className="fancy_six_odds">
                                                                                                                    <div _ngcontent-mck-c63="">

                                                                                                                    </div>
                                                                                                                    <div _ngcontent-mck-c63="">
                                                                                                                    </div>
                                                                                                                    <div _ngcontent-mck-c63="">
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <button onClick={() => {
                                                                                                                    setResultData({
                                                                                                                        winerId: ""
                                                                                                                    })
                                                                                                                    openResultPop(session)
                                                                                                                }} _ngcontent-mck-c63="" className="btn btn-primary text-white d-none-mobile" fdprocessedid="2870zc">
                                                                                                                    Close
                                                                                                                </button>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                </app-fancy-detail>
                                                                            </div>
                                                                        </tab>
                                                                    </div>
                                                                </div>
                                                            </tabset>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div style={{ marginTop: "150px" }} id='navbar' _ngcontent-ygh-c66="" className="col-md-4 px-0 rightBar">
                            {
                                <div className="tv-container">
                                    <div onClick={() => {
                                        // TviframeId ? closeLiveStream() : getLiveStreams()
                                    }} className="tv-title">
                                        <h4 className="mb-0 bet-slip-title">tv</h4>
                                        <i style={{ color: "white", padding: "4px 12px", float: "right" }} className='fa fa-tv' />
                                    </div>
                                    <div id='dvPlayerMainMob' className='iframe-tvlive d-none-mobile'></div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {
                resultPop && (
                    <div _ngcontent-tpi-c33="" id="result-popup2" tabindex="-1" aria-labelledby="result-popup2" class="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
                        <div _ngcontent-tpi-c33="" class="modal-dialog">
                            <div _ngcontent-tpi-c33="" class="modal-content">
                                {
                                    loader ? (
                                        <div>Loading...</div>
                                    ) : (
                                        <>
                                            <div _ngcontent-tpi-c33="" class="modal-header text-dark">
                                                <h1 _ngcontent-tpi-c33="" id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">{resultPop && resultPop.stMarketName}</h1>
                                                <button onClick={() => setResultPop()} _ngcontent-tpi-c33="" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                                            </div>
                                            <div _ngcontent-tpi-c33="" class="modal-body">
                                                <div>
                                                    <input type="number" onChange={onResultDChange} value={resultData.winerId} name='winerId' />
                                                </div>
                                                <button onClick={() => {
                                                    dispatch(loaderStart())
                                                    saveResult(resultPop.stMarketID, resultData.winerId, resultPop.stMarketName).then((data) => {
                                                        if (data?.success) {
                                                            toast.success("Result has been uploaded successfully")
                                                        } else {
                                                            toast.error("Server error")
                                                        }
                                                        dispatch(loaderStop())
                                                    })
                                                }} data-bs-dismiss="modal" className='btn btn-danger'>Close</button>
                                            </div>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                )
            }
            <div _ngcontent-tpi-c33="" id="delete-popup" tabindex="-1" aria-labelledby="delete-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div _ngcontent-tpi-c33="" class="modal-dialog">
                    <div _ngcontent-tpi-c33="" class="modal-content">
                        {
                            loader ? (
                                <div>Loading...</div>
                            ) : (
                                <>
                                    <div _ngcontent-tpi-c33="" class="modal-header text-dark">
                                        <h1 _ngcontent-tpi-c33="" id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">{resultPop && resultPop.stMarketName}</h1>
                                        <button _ngcontent-tpi-c33="" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                                    </div>
                                    <div _ngcontent-tpi-c33="" class="modal-body">
                                        <div className=''>Do you want to delete this market?</div>
                                        <button onClick={() => {
                                            dispatch(loaderStart())
                                            saveResult(resultPop.stMarketID, "Delete", resultPop.stMarketName).then((data) => {
                                                if (data?.success) {
                                                    toast.success("Result has been uploaded successfully")
                                                } else {
                                                    toast.error("Server error")
                                                }
                                                dispatch(loaderStop())
                                            })
                                        }} className='btn btn-danger'>Delete</button>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
